document.addEventListener("DOMContentLoaded", function(event) {

	let swiperIndex = document.querySelector(".JS-index-slider");
	const swiper = new Swiper(swiperIndex, {

		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		speed: 1000,
	});
});